import { AssetTag } from '../../types';
import { Measurement, MeasurementDimension } from '../../../query/query.types';

// User-facing label — update here when final naming is confirmed
export const ASSET_TAG_CATEGORY_LABEL = 'Asset Tags';

// Internal dimension key prefix — must NOT change (persisted in dashboards, alerts, saved filters)
export const DEVICE_TAG_DIMENSION_PREFIX = 'i_device_tags ->> ';
export const DEVICE_TAG_DIMENSION_PREFIX_REGEX = new RegExp(`^${DEVICE_TAG_DIMENSION_PREFIX}'\\w+'$`);

export function isAssetTagDimensionKey(dimensionKey: string): boolean {
  return DEVICE_TAG_DIMENSION_PREFIX_REGEX.test(dimensionKey);
}

export function getAssetTagDimensionKey(tagName: string): string {
  return `${DEVICE_TAG_DIMENSION_PREFIX}'${tagName}'`;
}

export function getTagNameFromDimensionKey(dimensionKey: string): string | undefined {
  if (!dimensionKey.startsWith(DEVICE_TAG_DIMENSION_PREFIX)) {
    return undefined;
  }
  const raw = dimensionKey.slice(DEVICE_TAG_DIMENSION_PREFIX.length);
  if (raw.startsWith("'") && raw.endsWith("'")) {
    return raw.slice(1, -1);
  }
  return raw;
}

export function transformAssetTagDimensions(tags: AssetTag[]): Record<string, MeasurementDimension> {
  return tags.reduce<Record<string, MeasurementDimension>>((acc, tag) => {
    acc[getAssetTagDimensionKey(tag.name)] = {
      Label: tag.display_name,
      Column: getAssetTagDimensionKey(tag.name),
      Alias: tag.name,
      Type: 'string',
      Category: ASSET_TAG_CATEGORY_LABEL
    };
    return acc;
  }, {});
}

export function getAssetTagKeysByDisplayName(measurements: Measurement[]): Record<string, string> {
  if (!measurements.length) {
    return {};
  }
  const result: Record<string, string> = {};
  for (const [key, dim] of Object.entries(measurements[0].storage.Dimensions)) {
    if (key.startsWith(DEVICE_TAG_DIMENSION_PREFIX) && dim.Label) {
      result[dim.Label] = key;
    }
  }
  return result;
}

export function augmentMeasurementsWithAssetTags(measurements: Measurement[], tags: AssetTag[]): Measurement[] {
  if (!tags.length) {
    return measurements;
  }

  const tagDimensions = transformAssetTagDimensions(tags);

  return measurements.map((measurement) => ({
    ...measurement,
    storage: {
      ...measurement.storage,
      Dimensions: {
        ...measurement.storage.Dimensions,
        ...tagDimensions
      }
    }
  }));
}
